
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsors",
      function () {
        return require("private-next-pages/sponsors/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsors"])
      });
    }
  